import { EventType } from "@/types/event-template-alternative-user";
import { BaseService } from "./BaseService";

class EventTypeService extends BaseService<EventType> {
  constructor() {
    super("/api/event-types");
  }
}

export const eventTypeService = new EventTypeService();
